var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("Here’s some background on Tommy: He’s gay, and a HS senior. He’s really smart and when it comes to safer sex, he’s like a human Wikipedia- you can ask him anything and he’ll know the answer.")])])}
var staticRenderFns = []

export { render, staticRenderFns }